<template>
  <form class="form-horizontal" method="post" @submit.prevent="submit">
    <div class="form-group m-b-20" :class="{ 'has-error': codeError }">
      <label for="mfa-code">
        <span v-if="method === 'username-password:sms'">{{
          trans("auth.keyLabel")
        }}</span>
        <span v-else>{{ trans("auth.authAppEnterCodePlaceholder") }}</span>
      </label>

      <div class="code-inputs">
        <input
          id="mfa-code"
          ref="codeInput"
          v-model="code"
          type="text"
          inputmode="numeric"
          maxlength="6"
          pattern="\d{6}"
          class="form-control code-box"
          autocomplete="one-time-code"
          required
          data-test="mfa-code-input"
          @input="handleInput"
        />
      </div>

      <span v-if="codeError" class="help-block">
        <strong>{{ codeError }}</strong>
      </span>
    </div>

    <div v-if="method === 'username-password:sms'" class="resend-btn mb-3">
      <a v-if="resendAvailable" href="#" @click.prevent="resend">
        {{ trans("auth.resendCode") }}
      </a>
      <span v-else>
        {{ trans("auth.resendAvailableIn") }}
        {{ resendTimer }}
        {{ trans("auth.seconds") }}
      </span>
    </div>

    <div class="form-group account-btn text-center m-t-10">
      <clip-loader v-show="loading" />
      <button
        v-if="!loading"
        class="btn btn-custom btn-block btn-lg"
        type="submit"
        data-test="mfa-submit"
      >
        {{ trans("auth.tokenButtonConfirm") }}
      </button>
    </div>
  </form>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { practitionerHttpService } from "../../app/practitioner-portal/store/practitioner-http-service";
import { navigateToHomepage } from "./helpers/authHelpers";
import ClipLoader from "../Utils/ClipLoader.vue";

const props = defineProps({
  method: { type: String, required: true },
  token: { type: String, required: true },
});

const RESEND_DELAY = 20;

const code = ref("");
const codeError = ref("");
const loading = ref(false);
const resendAvailable = ref(true);
const resendTimer = ref(RESEND_DELAY);
const codeInput = ref(null);

onMounted(() => codeInput.value?.focus());

const handleInput = (event) => {
  const value = event.target.value.replace(/\D/g, "");
  if (/^\d{0,6}$/.test(value)) {
    code.value = value;
  }
};

const submit = () => {
  codeError.value = "";
  loading.value = true;

  practitionerHttpService
    .post("/api/internal/auth/" + props.method + "/verify", {
      token: props.token,
      key: code.value,
    })
    .then((response) => {
      loading.value = false;
      localStorage.removeItem("last_query_uri");
      navigateToHomepage(response);
    })
    .catch((error) => {
      loading.value = false;
      if (error.response?.status === 422 || error.response?.status === 429) {
        codeError.value = error.response.data.key ?? "";
      }
    });
};

const startResendCooldown = () => {
  resendAvailable.value = false;
  resendTimer.value = RESEND_DELAY;
  const interval = setInterval(() => {
    resendTimer.value--;
    if (resendTimer.value === 0) {
      clearInterval(interval);
      resendAvailable.value = true;
    }
  }, 1000);
};

const resend = () => {
  practitionerHttpService
    .post("/api/internal/auth/sms/resend", { token: props.token })
    .then(() => startResendCooldown());
};
</script>
